import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartHeaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    title: {
        alignItems: "center",
        flexDirection: "row"
    }
});

export const useStyles = ({
    spaces
}: ChartHeaderDynamicStyleType) => {
    const styles = {
        title: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
